import React from 'react';
import MainLayOut from '../MainLayOut/index';
import context, {
  AppContextProvider,
  useAppContext,
} from '../../Utils/context';
import KenSnackbar from '../../Components/KenSnackbar/index';
import KenLoader from '../../Components/KenLoader/index';
//import history from '../../Utils/history';
import {
  getAxiosInstance,
  getConfig,
  getETLAxiosInstance,
} from '../../Utils/apiServices';
import { Redirect, Route, Switch, useHistory } from 'react-router';
import LoginPage from '../LoginPage';
import routes from '../../Utils/routes.json';
import { useSnackbar } from 'notistack';
import Slide from '@material-ui/core/Slide';
import DashboardPage from '../DashboardPage';

import AcademicsPlanner from '../AcademicsPlanner/index';
import AdminPortal from '../AdminPortal/index';

export const ProtectedRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        JSON.parse(localStorage.getItem('loggedIn')) ? (
          <Component {...props} />
        ) : (
          <Redirect to={`${routes.login}`} />
        )
      }
    />
  );
};

function Index(props) {
  const history = useHistory();
  // const { enqueueSnackbar } = useSnackbar();

  // // for global loader
  // const [loading, setLoading] = React.useState(false);

  // const handleLoader = (val) => {
  //   if (val !== undefined) {
  //     setLoading(val);
  //   } else {
  //     setLoading(!loading);
  //   }
  // };

  const [config, setConfig] = React.useState();
  const [loggedIn, setLoggedIn] = React.useState(false);
  const [axiosInstance, setAxiosInstance] = React.useState();

  // const handleSnackbarOpen = (severity, message) => {
  //   enqueueSnackbar(message, {
  //     anchorOrigin: {
  //       vertical: 'bottom',
  //       horizontal: 'right',
  //     },
  //     variant: severity,
  //     TransitionComponent: Slide,
  //   });
  // };

  const { handleLoader, handleSnackbarOpen } = useAppContext();

  React.useEffect(() => {
    console.log('test for Access Token');
    handleLoader(true);
    getConfig()
      .then((res) => {
        if (!res[0]) return;
        setAxiosInstance(getAxiosInstance(res[0]));
        getETLAxiosInstance(res);

        setConfig(res[0]?.config);
        handleLoader(false);
        // history.push('/app');

        const loggedIn = JSON.parse(localStorage.getItem('loggedIn'));

        if (!loggedIn) {
          handleLoader(false);

          history.replace(`${routes.login}`);
        } else {
          handleLoader(false);
          // history.push(`${routes.main}`);
          setLoggedIn(true);
        }
      })
      .catch((err) => {
        console.log(err, 'error');
        handleSnackbarOpen('warning', 'Error getting config');
        handleLoader(false);
      });

    // const loggedIn = JSON.parse(localStorage.getItem('loggedIn'));
    // console.log('[Index.js] loggedIn:: ', loggedIn);

    // if (!loggedIn) {
    // 	handleLoader(false);
    // 	history.replace(`${routes.login}`);
    // } else {
    // 	handleLoader(false);
    // 	history.push(`${routes.main}`);
    // }
  }, [loggedIn]);


  return (
    <div>
      {/* <context.Provider
        value={{
          handleLoader: handleLoader,
          handleSnackbarOpen: handleSnackbarOpen,
          config: config,
        }}
      > */}
      {!config || !axiosInstance ? (
        <KenLoader />
      ) : (
        <Switch>
          <Route exact path="/">
            <Redirect to="/login" />
          </Route>
          <Route path="/login">
            {loggedIn ? <Redirect to="/app" /> : <LoginPage />}
          </Route>
          <Route exact path="/dashboard">
            <DashboardPage />
          </Route>
          {/* <Route path="/app/academics-planner">
              <AcademicsPlanner />
            </Route>
            <Route path="/app/admin-management">
              <AdminPortal />
            </Route> */}
          <Route path="/app">
            <MainLayOut setLoggedIn={setLoggedIn} />
          </Route>

          {/* <ProtectedRoute exact path="/app">
              <MainLayOut />
            </ProtectedRoute> */}

          {/* <ProtectedRoute
						exact
						path='/app'
						component={MainLayOut}
						render={() => <Redirect to={`/app`} />}
					></ProtectedRoute> */}
        </Switch>
      )}
      {/* </context.Provider> */}
    </div>
  );
}

export default function AppIndex(props) {
  const { enqueueSnackbar } = useSnackbar();

  const handleSnackbarOpen = (severity, message) => {
    enqueueSnackbar(message, {
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
      variant: severity,
      TransitionComponent: Slide,
    });
  };

  return (
    <AppContextProvider initValue={{ handleSnackbarOpen }}>
      <Index {...props} />
    </AppContextProvider>
  );
}
